import * as z from 'zod';
import { TicketStatus, TicketPriority } from '@/generated/prisma/enums';

export const CreateSupportTicketSchema = z.object({
  subject: z
    .string()
    .min(3, { message: 'Subject must be at least 3 characters' })
    .max(200, { message: 'Subject must be 200 characters or less' }),
  description: z
    .string()
    .min(10, { message: 'Description must be at least 10 characters' })
    .max(5000, { message: 'Description must be 5000 characters or less' }),
  priority: z.nativeEnum(TicketPriority).optional(),
});

export const CreateTicketMessageSchema = z.object({
  ticketId: z.string().cuid({ message: 'Invalid ticket id' }),
  body: z
    .string()
    .min(1, { message: 'Message cannot be empty' })
    .max(5000, { message: 'Message must be 5000 characters or less' }),
});

export const UpdateTicketStatusSchema = z.object({
  ticketId: z.string().cuid({ message: 'Invalid ticket id' }),
  status: z.nativeEnum(TicketStatus),
});
